import { AuthenticateUserResponse } from '@domain/entities';
import { AuthenticateUserResponseDTO } from '../dtos/auth.dto';

export class AuthMapper {
  authenticateUserToDomain(
    dto: AuthenticateUserResponseDTO
  ): AuthenticateUserResponse {
    return {
      success: dto.success,
      data: {
        groups: dto.data.groups.map(group => ({
          groupName: group.groupName,
          groupId: group.groupId,
        })),
        userAcct: dto.data.userAcct,
        userName: dto.data.userName,
        lastLoginDtm: dto.data.lastLoginDtm,
      },
    };
  }
}
